import LeaderBadge from './components/LeaderBadge'
import LeaderScore from './components/LeaderScore'
import MiniCard from './components/MiniCard'

const Category = {
  LeaderBadge,
  LeaderScore,
  MiniCard,
}

export default Category
